/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Start_Trial_ButtonInputs */



/**
* | output |
* | --- |
* | "Start 7-Day Free Trial" |
*
* @param {Signup_Start_Trial_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_start_trial_button = /** @type {((inputs?: Signup_Start_Trial_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Start_Trial_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commencer l'Essai Gratuit de 7 Jours")
	if (locale === "de") return /** @type {LocalizedString} */ ("7 Tage kostenlos testen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizia la prova gratuita di 7 giorni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начните 7-дневную бесплатную пробную версию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comience una prueba gratuita de 7 días")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始7天免费试用")
	if (locale === "ja") return /** @type {LocalizedString} */ ("7日間無料トライアルを開始")
	if (locale === "hi") return /** @type {LocalizedString} */ ("7 दिन का निःशुल्क परीक्षण शुरू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comece seu teste gratuito de 7 dias")
	return /** @type {LocalizedString} */ ("Start 7-Day Free Trial")
});